"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { Suspense } from "react";
import { FeaturedItemSlide } from "../FeaturedItemSlide";
import { FeaturedItemSlideFragment } from "../FeaturedItemSlide/FeaturedItemSlide.fragment";
import { FeaturedItemsCarouselSkeleton } from "./FeaturedItemsCarouselSkeleton";
const query = graphql(`
    query FeaturedItemsCarouselLayoutQuery($ids: [String!]!) {
      itemsByIds(ids: $ids) {
        id
        ...FeaturedItemSlide
      }
    }
  `, [FeaturedItemSlideFragment]);
function BaseFeaturedItemsCarouselLayout(t0) {
  const $ = _c(7);
  const {
    itemIds
  } = t0;
  let t1;
  if ($[0] !== itemIds) {
    t1 = {
      ids: itemIds
    };
    $[0] = itemIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !itemIds.length;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      query,
      variables: t1,
      pause: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [t4] = useQuery(t3);
  const {
    data
  } = t4;
  let t5;
  if ($[5] !== data?.itemsByIds) {
    t5 = data?.itemsByIds.map(_temp);
    $[5] = data?.itemsByIds;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(item) {
  if (!item) {
    return null;
  }
  return <FeaturedItemSlide item={item} key={item.id} />;
}
export function FeaturedItemsCarouselLayout(t0) {
  const $ = _c(9);
  const {
    sections
  } = t0;
  let t1;
  if ($[0] !== sections) {
    t1 = sections?.flatMap(_temp2) ?? [];
    $[0] = sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const itemIds = t1;
  let t2;
  if ($[2] !== itemIds.length) {
    t2 = <FeaturedItemsCarouselSkeleton slides={itemIds.length} />;
    $[2] = itemIds.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== itemIds) {
    t3 = <BaseFeaturedItemsCarouselLayout itemIds={itemIds} />;
    $[4] = itemIds;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Suspense fallback={t2}>{t3}</Suspense>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp2(item) {
  return item?.__typename === "FeatureContentBlock" && item.itemId ? [item.itemId] : [];
}